import {fork, takeEvery, takeLatest, put, putResolve, select} from "redux-saga/effects";
import {
    ChatMsgActions,
    addChatMsgAction,
    sendMessageAction,
    showLadingIconAction,
    loadHistoryBySessionAction,
    retrieveLastSessionResultAction,
    reSetChatMsgResultAction,
    updateNotifyStatus,
    updateFrontendAction,
    updateActiveContextAction, removeChatMsgAction
} from "../actions/chat-msg-actions";
import {ActionPayload, WelcomeMsg} from "../types/common-types";
import {DetectIntentReq, ChatMsg, ConversationSessionResp, ReportUserAction, DetectIntentData, DownloadByButtonReq} from "../types/chat-msg-types";
import {
    BUDDY_COMMON,
    BUDDY_MSG,
    SESSION_ID,
    USER_MSG,
    CONFIG,
    FEEDBACK,
    DETECT_UN_ACTIVITY,
    FEEDBACK_SHOW,
    TRIGGER_WELCOME_INTENT, CUSTOMER_INACTIVE2, CLICKED_WELCOME, TRIGGER_DOWNTIME_INTENT
} from "../common/config";
import {detectIntent, getSessionId, retrieveChatHistoryBySessionIdApi, repostUserActionApi, downloadByButtonApi} from "../common/api";
import {setSubmitOtpInfoKillSwitchAction} from "../actions/chat-authentication-actions";
import {clearInputAction, showSuggestionAction} from "../actions/chat-suggestion-actions";
import {getParameterValueFromUrl} from "../utils/utils";
import { config } from "process";
import { CommonConstant } from "../common/CommonConstant";

function* getConversationSessionId(payload: any) {
    const needShowIntent = payload.payload;
    const resp = (yield getSessionId()) as ConversationSessionResp;

    if (resp && resp.conversationSessionId) {
        //paas session ID to adobe
        try {
            parent.postMessage(JSON.stringify({action:"chatbotSessionInitiated",sessionId:resp.conversationSessionId}), CONFIG.TARGET_ORIGIN)
        }catch (e) {
            console.log("parent.postMessage error",e)
        }

        //rest submit feedback status
        localStorage.setItem("submitFeedback", "false");
        // localStorage.setItem("activeIndex", "0");
        sessionStorage.setItem(SESSION_ID, resp.conversationSessionId);
        sessionStorage.setItem(FEEDBACK,"true");
        sessionStorage.setItem(FEEDBACK_SHOW,"true");
        sessionStorage.setItem(DETECT_UN_ACTIVITY,"true");
        if(!sessionStorage.getItem("showDowntimeIntent")) {
            yield put(sendMessageAction({message: CONFIG.DOWNTIME_UTTERANCE, name: "", type:TRIGGER_DOWNTIME_INTENT, notSaveToMongo: true, exactMatch: true,forceLanguage:localStorage.getItem(CommonConstant.CURRENT_LANGUAGE)}))
        } else {
            let url = sessionStorage.getItem("url")
            if (url && needShowIntent) {
                yield put(loadHistoryBySessionAction(true));//yield put(sendMessageAction({message: url, name: "",notSaveToMongo: true,exactMatch: true}));
            } else {
                yield put(loadHistoryBySessionAction());
            }
        }
    } else {
        // let showErrorMsg = sessionStorage.getItem("showErrorMsg");
        // if (showErrorMsg != 'true') {
        // sessionStorage.setItem("showErrorMsg", "true");
        let errorMsg = CONFIG.ERROR_MSG;
        const commonMsg: ChatMsg = {msg: errorMsg, type: BUDDY_COMMON, date: new Date()};
        yield put(addChatMsgAction(commonMsg));
        yield put(showLadingIconAction(false));
        // }
    }
}

function* triggerInactivity(payload: any) {
    console.log("triggerInactivity payload", payload);
    if (payload && payload.payload && payload.payload.action) {
        yield put(payload.payload.action);
    }
}


function judge(chatMsg: any): boolean {
    if (chatMsg.msg && chatMsg.msg.fulfillmentMessages
        && chatMsg.msg.fulfillmentMessages[0].richResponse
        && chatMsg.msg.fulfillmentMessages[0].richResponse.action
        && chatMsg.msg.fulfillmentMessages[0].richResponse.action.id === "1004") {
        if (sessionStorage.getItem(FEEDBACK_SHOW) === "false") {
            return false
        } else {
            sessionStorage.setItem(FEEDBACK_SHOW, "false")
            return true;
        }
    }
    return true
}


function* sendMessage(sagaMsg: ActionPayload) {
    yield put(setSubmitOtpInfoKillSwitchAction({killSwitchSendOtpInfo: "", canClickSubmit: 3}));
    const req: DetectIntentReq = sagaMsg.payload;
    const welcomeMsg: WelcomeMsg = yield select((state) => state.chatCommon.welcomeMsg);
   
    let resp: any;
    if (sagaMsg.type === BUDDY_COMMON) {
        return;
    }
    const url = getParameterValueFromUrl("url");
    req.covStartUrl = url;

     yield put(showSuggestionAction(false, []));
    yield put(showLadingIconAction(true));
    let req1={...req};
    req1.encodeFlag = welcomeMsg.buddyTextConfiguration?.inferEncoding;
    if(welcomeMsg.buddyTextConfiguration?.inferEncoding){
        req1.message=btoa(encodeURIComponent(req1.message));
        req1.name=btoa(encodeURIComponent(req1.name));
    }
    resp = yield detectIntent(req1);

    const haveNotify = yield select((state) => state.chatMsg.haveNotify);
    if (haveNotify) {
        sessionStorage.setItem("needNotify", "false");
        localStorage.setItem("needShowFeedback", "true");
        yield put(updateNotifyStatus(false));
    }
    if (req.message === CONFIG.NOEND_CHAT || req.message === CONFIG.NOEND_CHINESE_CHAT) {
        localStorage.setItem("needShowFeedback", "false");
        sessionStorage.setItem("needNotify", "false");
    
    }

    if (resp && resp.status === "success") {
        if (resp.data && resp.data.language){
            localStorage.setItem(CommonConstant.CURRENT_LANGUAGE,resp.data.language);
        }
        if (req.message == CONFIG.DOWNTIME_UTTERANCE) {
            sessionStorage.setItem("showDowntimeIntent", "true")
            if (url) {
                yield put(sendMessageAction({message: url, type:TRIGGER_WELCOME_INTENT, name: "", notSaveToMongo: true, exactMatch: true}));
            }
        }
        if(req.type&&req.type===DETECT_UN_ACTIVITY){
            sessionStorage.setItem(DETECT_UN_ACTIVITY,"false");
        }
        if(req.type&&req.type===CUSTOMER_INACTIVE2){
            sessionStorage.setItem(FEEDBACK,"false");
        }
        if (resp.maskMsg && resp.maskMsg.length > 1) {
            const maskMsg: ChatMsg = {msg: resp.maskMsg, type: USER_MSG, date: new Date(), parentQuery: req.message};
            yield put(removeChatMsgAction());
            yield put(addChatMsgAction(maskMsg));
            yield put(updateFrontendAction());
        }

        let buddyMsg: ChatMsg = {msg: resp.data, type: BUDDY_MSG, date: new Date(), convId: resp.convId, parentQuery: req.message};
        if (req.type&&req.type===TRIGGER_WELCOME_INTENT){
            buddyMsg = {...buddyMsg,intentType:CLICKED_WELCOME}
        }
        if (req.type&&req.type===TRIGGER_DOWNTIME_INTENT){
            buddyMsg = {...buddyMsg,intentType:TRIGGER_DOWNTIME_INTENT}
        }
        let activeContext: string[] = [];
        try {
            const result: DetectIntentData = resp.data as DetectIntentData;
            activeContext = result.activeContext;
        } catch (error) {
            console.log("can not get active context");
        }
        yield put(updateActiveContextAction(activeContext));
        if(judge(buddyMsg)) {
            yield put(addChatMsgAction(buddyMsg));
        }
        yield put(showLadingIconAction(false));

        //mask phone message
        if (resp.data && resp.data.fulfillmentMessages
            && resp.data.fulfillmentMessages[0].richResponse
            && resp.data.fulfillmentMessages[0].richResponse.action
            && resp.data.fulfillmentMessages[0].richResponse.action.id === "1001") {
            yield put(updateFrontendAction(resp.data.fulfillmentMessages[0].richResponse.action));
        }

        //config surveyId
        if (resp.data && resp.data.fulfillmentMessages
            && resp.data.fulfillmentMessages[0].richResponse
            && resp.data.fulfillmentMessages[0].richResponse.action
            && resp.data.fulfillmentMessages[0].richResponse.action.id === "1004") {
            yield put(updateFrontendAction(resp.data.fulfillmentMessages[0].richResponse.action));
        }

    } else if (resp && resp.status === 401) {
        //reset chatMas
        yield putResolve(reSetChatMsgResultAction());
        //when detectIntent return 401,to get a new session again,and then detectIntent
        const resp: ConversationSessionResp = yield getSessionId();
        if (resp && resp.conversationSessionId) {
            console.log("reset chat msg done====");
            try {
                parent.postMessage(JSON.stringify({action:"chatbotSessionInitiated",sessionId:resp.conversationSessionId}), CONFIG.TARGET_ORIGIN)
            }catch (e) {
                console.log("parent.postMessage error",e)
            }

            sessionStorage.setItem(SESSION_ID, resp.conversationSessionId);
            //resend add userMsg
            const url = getParameterValueFromUrl("url");
            if (url == req.message) {   // for get welcome intent
                yield put(sendMessageAction({message: url, type:TRIGGER_WELCOME_INTENT, name: "", notSaveToMongo: true, exactMatch: true}));
            } else if(req.message == CONFIG.DOWNTIME_UTTERANCE) {
                yield put(sendMessageAction({message: CONFIG.DOWNTIME_UTTERANCE, name: "", type:TRIGGER_DOWNTIME_INTENT, notSaveToMongo: true, exactMatch: true,forceLanguage:localStorage.getItem(CommonConstant.CURRENT_LANGUAGE)}))
            } else {
                const userMsg: ChatMsg = {msg: req.message, type: USER_MSG, date: new Date(), parentQuery: req.message};
                yield put(addChatMsgAction(userMsg));
                yield put(sendMessageAction(req));
            }
        }
    } else {
        let errorMsg = CONFIG.ERROR_MSG;
        // if (resp && resp.status) {
        //     errorMsg = "Error Code : " + resp.status + ". An error has occured, please try again.<br>If the problem continues, contact IT Tech Service Desk (ittsd@ocbc.com) for assistance."
        // } else {
        //     errorMsg = "An error has occured, please try again.<br>If the problem continues, contact IT Tech Service Desk (ittsd@ocbc.com) for assistance."
        // }
        // for get welcome intent      url == req.message 
        const url = getParameterValueFromUrl("url");
        const welcomeIntent = "query-welcome-global";
        console.log("detect intent error resp: ", resp);
        if (url == req.message && resp && resp.data && resp.data.errorCode === "CONV-10016") {
            // show default intent
            console.log("get response fron EDSP is null");
            yield put(sendMessageAction({message: welcomeIntent, name: "",type:TRIGGER_WELCOME_INTENT, notSaveToMongo: true, exactMatch: true}));
        } else if (resp && resp.data && resp.data.errorCode === "CONV-10016" && req.message == CONFIG.DOWNTIME_UTTERANCE) {
            console.log("get response fron EDSP is null");
            if (url) {
                yield put(sendMessageAction({message: url, type: TRIGGER_WELCOME_INTENT ,name: "", notSaveToMongo: true, exactMatch: true}));
            } else {
                yield put(sendMessageAction({message: welcomeIntent, name: "",type:TRIGGER_WELCOME_INTENT, notSaveToMongo: true, exactMatch: true}));
            }
        } else {
            const commonMsg: ChatMsg = {msg: errorMsg, type: BUDDY_COMMON, date: new Date(), parentQuery: req.message};
            yield put(addChatMsgAction(commonMsg));
        }
        yield put(showLadingIconAction(false));
    }
}

function* getHistoryBySessionId(payload: any) {
    // console.log("load history start payload", payload);
    const resp = yield retrieveChatHistoryBySessionIdApi();
    let newChatMsg: ChatMsg[] = [];
    let activeContext: string[] = [];

    if (resp && resp.status === "success") {
        if (resp.data && resp.data.length > 0) {
            for (let i = 0; i < resp.data.length; i++) {
                if (resp.data[i].content && resp.data[i].requesterType === 'USER') {
                    const userMsg: ChatMsg = {
                        msg: resp.data[i].content,
                        type: USER_MSG,
                        isHistoryMsg: true,
                        date: resp.data[i].createTime
                    };
                    newChatMsg.push(userMsg);
                } else {
                    if (resp.data[i].content) {
                        const buddyMsg: ChatMsg = {
                            msg: JSON.parse(resp.data[i].content).data,
                            type: BUDDY_MSG,
                            isHistoryMsg: true,
                            date: resp.data[i].createTime
                        };
                        
                        try {
                            const result: DetectIntentData = JSON.parse(resp.data[i].content).data as DetectIntentData;
                            activeContext = result.activeContext;
                        } catch (error) {
                            console.log("can not get active context");
                        }

                        newChatMsg.push(buddyMsg);
                    }
                }
            }
            yield put(updateActiveContextAction(activeContext));
            const result = {
                newChatMsg: newChatMsg
            }
            if (payload && payload.payload) {
                console.log("newChatMsg: ", newChatMsg);
                yield putResolve(retrieveLastSessionResultAction(result));
                let url = sessionStorage.getItem("url");
                if (url) {
                    yield put(sendMessageAction({message: url, type: TRIGGER_WELCOME_INTENT ,name: "", notSaveToMongo: true, exactMatch: true}));
                }
            } else {
                yield put(retrieveLastSessionResultAction(result));
            }

            // if(newChatMsg.length > 2) {
            //     //set history date
            //     yield put(setNewHistoryDateAction(new Date(resp.data.date).toLocaleTimeString("en-US", {
            //         year: "numeric",
            //         month: "short",
            //         day: "numeric",
            //         hour: "2-digit",
            //         minute: "2-digit",
            //         second: "2-digit",
            //     }).toString()));
            // }
        } else {
            // no more data
            const result = {
                newChatMsg: []
            }
            if (payload && payload.payload) {
                yield putResolve(retrieveLastSessionResultAction(result));
                let url = sessionStorage.getItem("url");
                if (url) {
                    yield put(sendMessageAction({message: url,type:TRIGGER_WELCOME_INTENT, name: "", notSaveToMongo: true, exactMatch: true}));
                }
            } else {
                yield put(retrieveLastSessionResultAction(result));
            }
            //yield put(retrieveLastSessionResultAction(result));
        }
    } else if (resp && resp.status === 401) {
        //reset chatMas
        yield putResolve(reSetChatMsgResultAction());
        //when detectIntent return 401,to get a new session again,and then detectIntent
        const resp: ConversationSessionResp = yield getSessionId();
        if (resp && resp.conversationSessionId) {
            sessionStorage.setItem(SESSION_ID, resp.conversationSessionId);
            yield put(loadHistoryBySessionAction());
        }
    } else {
        // const result = {
        //     queryDate: payload.payload,
        //     hasMoreHistory: true,
        //     newChatMsg: []
        // }
        //yield put(retrieveLastSessionResultAction(result));
    }
}

function* reportUserAction(payload: any) {
    const req: ReportUserAction = payload.payload;
    yield repostUserActionApi(req);
}

function* downloadByButton(payload: any) {
    const req: DownloadByButtonReq = {
        buttonUrl: payload.payload.buttonUrl
    };
    const aElement = document.createElement("a");
    aElement.download = payload.payload.fileName;
    aElement.style.display = "none";
    try {
        const resp = yield downloadByButtonApi(req);
        if (resp.status && resp.status != 200) {
            console.error('down load by button failed with http status:' + resp.status);
            aElement.href = payload.payload.buttonUrl;
        } else {
            const blob = new Blob([resp]);
            aElement.href = window.URL.createObjectURL(blob);
        }
        document.body.appendChild(aElement);
        aElement.click();
        URL.revokeObjectURL(aElement.href);
        document.body.removeChild(aElement);
    } catch {
        console.error('down load by button failed');
        aElement.href = payload.payload.buttonUrl;
        document.body.appendChild(aElement);
        aElement.click();
        URL.revokeObjectURL(aElement.href);
        document.body.removeChild(aElement);
    }
}

function* mySaga() {
    yield takeLatest(ChatMsgActions.GET_CONVERSATION_SESSION_ID, getConversationSessionId);
    yield takeEvery(ChatMsgActions.SEND_INPUT_MESSAGE, sendMessage);
    yield takeLatest(ChatMsgActions.LOAD_HISTORY_BY_SESSION, getHistoryBySessionId);
    yield takeLatest(ChatMsgActions.TRIGGER_INACTIVITY_INTENT, triggerInactivity);
    yield takeLatest(ChatMsgActions.REPORT_USER_ACTION, reportUserAction);
    yield takeLatest(ChatMsgActions.DOWNLOAD_BY_BUTTON, downloadByButton);
}

const chatMsgSaga = [fork(mySaga)];

export default chatMsgSaga;